module.exports = __webpack_public_path__ + "static/media/BONDED_PAIR.71efe60f.svg";